import { usePageTitle } from "@/hooks/usePageTitle";

export function TermsOfServicePage() {
  usePageTitle("Naudojimo taisyklės");

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="mb-8 text-3xl font-bold text-gray-900">
        Naudojimo taisyklės
      </h1>

      <div className="space-y-8 text-gray-600">
        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            1. Bendrosios nuostatos
          </h2>
          <p>
            Šios naudojimo taisyklės (toliau – „Taisyklės") reglamentuoja
            Boardo platformos (toliau – „Platforma") naudojimą. Registruodamiesi
            ir naudodamiesi Platforma, jūs sutinkate laikytis šių Taisyklių.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            2. Platformos paskirtis
          </h2>
          <p>
            Platforma yra skirta stalo žaidimų pirkimui ir pardavimui tarp
            naudotojų. Platforma suteikia galimybę skelbti, ieškoti ir
            susisiekti dėl stalo žaidimų įsigijimo.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            3. Registracija ir paskyra
          </h2>
          <ul className="ml-6 list-disc space-y-1">
            <li>
              Norėdami naudotis visomis Platformos funkcijomis, turite
              užsiregistruoti ir susikurti paskyrą.
            </li>
            <li>
              Jūs esate atsakingi už savo paskyros saugumą ir prisijungimo
              duomenų konfidencialumą.
            </li>
            <li>
              Pateikta informacija turi būti teisinga ir aktuali.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            4. Skelbimų talpinimas
          </h2>
          <ul className="ml-6 list-disc space-y-1">
            <li>
              Skelbimuose pateikiama informacija turi būti tiksli ir
              atitikti tikrovę.
            </li>
            <li>
              Draudžiama skelbti netinkamą, įžeidžiantį ar neteisėtą turinį.
            </li>
            <li>
              Platforma pasilieka teisę pašalinti skelbimus, pažeidžiančius
              šias Taisykles.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            5. Naudotojų elgesys
          </h2>
          <p className="mb-2">Naudodamiesi Platforma, įsipareigojate:</p>
          <ul className="ml-6 list-disc space-y-1">
            <li>Elgtis sąžiningai ir pagarbiai su kitais naudotojais.</li>
            <li>Nenaudoti Platformos neteisėtiems tikslams.</li>
            <li>Nesiųsti nepageidaujamų žinučių (spam).</li>
            <li>
              Nepažeisti kitų naudotojų teisių ar Platformos veikimo.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            6. Atsakomybės ribojimas
          </h2>
          <p>
            Platforma yra tarpininkė tarp pirkėjų ir pardavėjų. Platforma
            neatsako už sandorių tarp naudotojų eigą, prekių kokybę ar
            pristatymą. Visi sandoriai vykdomi naudotojų atsakomybe.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            7. Paskyros sustabdymas
          </h2>
          <p>
            Platforma pasilieka teisę sustabdyti ar panaikinti naudotojo paskyrą
            be išankstinio įspėjimo, jei naudotojas pažeidžia šias Taisykles
            ar veikia nesąžiningai.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            8. Taisyklių keitimas
          </h2>
          <p>
            Platforma pasilieka teisę bet kuriuo metu keisti šias Taisykles.
            Apie esminius pakeitimus naudotojai bus informuojami Platformoje.
            Tolimesnis Platformos naudojimas po pakeitimų reiškia sutikimą su
            naujomis Taisyklėmis.
          </p>
        </section>

        <section>
          <h2 className="mb-3 text-xl font-semibold text-gray-900">
            9. Kontaktai
          </h2>
          <p>
            Dėl klausimų, susijusių su šiomis Taisyklėmis, kreipkitės el.
            paštu{" "}
            <a
              href="mailto:info@boardo.lt"
              className="text-primary-800 hover:text-primary-700"
            >
              info@boardo.lt
            </a>
            .
          </p>
        </section>

        <p className="pt-4 text-sm text-gray-400">
          Paskutinį kartą atnaujinta: 2026 m. kovo mėn.
        </p>
      </div>
    </div>
  );
}
